import { Object3D } from "three";
/**
 * Invisible Object3D used only to bind position.
 */
export class CalculationPoint extends Object3D {
    constructor(name, position) {
        super();
        this.name = name ?? "";
        position && this.position.copy(position);
        this.interceptedByRaycaster = false;
        this.visible = false;
    }
}
//# sourceMappingURL=CalculationPoint.js.map